import { render, staticRenderFns } from "./PaymentInfoSelectedCase.vue?vue&type=template&id=16870f9a&"
import script from "./PaymentInfoSelectedCase.vue?vue&type=script&lang=js&"
export * from "./PaymentInfoSelectedCase.vue?vue&type=script&lang=js&"
import style0 from "./PaymentInfoSelectedCase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PaymentInfoSelectedCase.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSimpleTable,VSkeletonLoader})
